import { type ReactNode, useEffect } from 'react';
import { useAppStore } from '@/store';
import type { BrandSpace } from '@/store/slices/brandScope';
import type { BrandIdentifiers, BrandSourceName } from './sources/types';

type BrandScopeProps = {
  sources: BrandSourceName[];
  space?: BrandSpace;
  resource?: BrandIdentifiers;
  children: ReactNode;
};

// gloss
export const BrandScope = ({ sources, space = 'hub', resource, children }: BrandScopeProps) => {
  const declare = useAppStore((s) => s.brandScope.declare);
  const reset = useAppStore((s) => s.brandScope.reset);

  const resourceKey = `${resource?.uuid ?? ''}|${resource?.brandID ?? ''}|${resource?.code ?? ''}`;
  const sourcesKey = sources.join(',');

  useEffect(() => {
    declare({ sources: sourcesKey.split(',') as BrandSourceName[], space, resource });
    return reset;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- the keys are the declaration's identity
  }, [sourcesKey, space, resourceKey, declare, reset]);

  return children;
};
